var _defs, _rect, _rect2, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaceDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 310,
    height: 100,
    viewBox: "0 0 310 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 310,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a0f26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#141a3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a1650"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "neb",
    cx: 0.8,
    cy: 0.3,
    r: 0.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b8def",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b8def",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ship",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b8def"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flame",
    x1: 1,
    y1: 0,
    x2: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f0c674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e05c6e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 310,
    height: 100,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 310,
    height: 100,
    fill: "url(#neb)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#dfe6ff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 18,
    r: 1.1,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 70,
    r: 0.9,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 30,
    r: 1.3,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 82,
    r: 0.8,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 14,
    r: 1,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 60,
    r: 0.9,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 24,
    r: 1.2,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285,
    cy: 78,
    r: 0.9,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 44,
    r: 0.7,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 55,
    r: 0.7,
    opacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 34,
    x2: 90,
    y2: 34,
    stroke: "#4caf7d",
    strokeWidth: 2,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 52,
    x2: 70,
    y2: 52,
    stroke: "#f0c674",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 68,
    x2: 110,
    y2: 68,
    stroke: "#5b8def",
    strokeWidth: 2,
    opacity: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 8,
    width: 3,
    height: 84,
    fill: "#aab6ff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 8,
    width: 4,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 22,
    width: 4,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 36,
    width: 4,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 50,
    width: 4,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 64,
    width: 4,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 78,
    width: 4,
    height: 7
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232 50 L200 40 L212 50 L200 60 Z",
    fill: "url(#flame)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 50 L214 39 L222 50 L214 61 Z",
    fill: "url(#ship)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227,
    cy: 50,
    r: 3.4,
    fill: "#0a0f26"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227,
    cy: 50,
    r: 2,
    fill: "#9fd0ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaceDark);
export default __webpack_public_path__ + "static/media/race__dark.145a937fbde8b3da3afc1ac6e0bdedd4.svg";
export { ForwardRef as ReactComponent };